export interface RheaTheme {
  colors: {
    background: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
    text: {
      primary: string;
      secondary: string;
      accent: string;
    };
    card: {
      background: string;
      hover: string;
      border: string;
    };
    accent: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
  };
}

export const defaultRheaTheme: RheaTheme = {
  colors: {
    background: {
      primary: '#1a1a1a',    // Dark background
      secondary: '#2d2d2d',  // Slightly lighter background
      tertiary: '#3d3d3d',   // Even lighter background
    },
    text: {
      primary: '#ffffff',    // White text
      secondary: '#a0a0a0',  // Gray text
      accent: '#60a5fa',     // Blue accent
    },
    card: {
      background: '#2d2d2d', // Card background
      hover: '#3d3d3d',      // Card hover state
      border: '#404040',     // Card border
    },
    accent: {
      primary: '#60a5fa',    // Primary accent (blue)
      secondary: '#34d399',  // Secondary accent (green)
      tertiary: '#f472b6',   // Tertiary accent (pink)
    },
  },
};

// CSS variable names for the theme
export const rheaThemeVars = {
  colors: {
    background: {
      primary: '--rhea-bg-primary',
      secondary: '--rhea-bg-secondary',
      tertiary: '--rhea-bg-tertiary',
    },
    text: {
      primary: '--rhea-text-primary',
      secondary: '--rhea-text-secondary',
      accent: '--rhea-text-accent',
    },
    card: {
      background: '--rhea-card-bg',
      hover: '--rhea-card-hover',
      border: '--rhea-card-border',
    },
    accent: {
      primary: '--rhea-accent-primary',
      secondary: '--rhea-accent-secondary',
      tertiary: '--rhea-accent-tertiary',
    },
  },
}; 